import { AddonTriggerContext } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useContext } from 'react';
import { useLifecycles } from 'react-use';

import { ChangeSubjectFn } from 'components/editorQuickRepliesDropdown/editorQuickRepliesDropdown.types';

import { QuickRepliesContent } from '../quickRepliesContent/quickRepliesContent';

type Props = {
  changeSubject?: ChangeSubjectFn;
  onOpen?: () => void;
  onClose?: () => void;
  enduserId?: string | null;
};

export const QuickRepliesTrigger = ({
  changeSubject,
  onOpen,
  onClose,
  enduserId = null,
}: Props): JSX.Element => {
  const { matchText, insertContent, eventEmitter } =
    useContext(AddonTriggerContext);

  useLifecycles(
    () => {
      ampli.quickRepliesOpened({ openedBy: 'editorTrigger' });
      onOpen?.();
    },
    () => {
      onClose?.();
    },
  );

  return (
    <QuickRepliesContent
      editorSearchTrigger={matchText}
      insertContent={insertContent}
      changeSubject={changeSubject}
      eventEmitter={eventEmitter}
      enduserId={enduserId}
    />
  );
};
